import React from "react";
import loadingGif from "./images/loading-min.gif"
import "./style.less";

const View = ({ isLoading, error }) => {

    if (isLoading) {
        return (
            <div className="com-loading flex center">
                <img width="100px" src={loadingGif} alt="" />
            </div>
        )
    }
    else if (error) {
        return <div>Sorry, there was a problem loading the page.</div>
    }
    else {
        return null;
    }
};

export default View;